var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.item.altaPrioridade)?_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('span',_vm._g({staticClass:"custom-tooltip",attrs:{"data-cy":("priorizaAltaPrioridade-" + (_vm.item.id))}},on),[_c('strong',[_vm._v("A")])])]}}],null,false,2396780515)},[_c('span',[_vm._v("Cirugia de alta prioridade")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }